// extracted by mini-css-extract-plugin
export default {"grid":"UFcZw","grid_type_days":"QBxhp","grid_type_month":"WXMLU","grid_type_years":"sGU4F"};